export default __webpack_public_path__ + "1c7da5050c26d828efa6d7ad54f3c7b5.png";